import { isObject } from "lodash";

export function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (["isOpen", "calendarOrderDateFilter", "forceCallApi"].includes(key)) continue;
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false;
    }
  }
  return true;
}

export const parseSelectedColumns = (newTableColumns, selectedColumns) => {
  // Note: resting the default checked columns first, then decide later if it should be displayed or not based on the user selected columns in the DB.
  for (const [columnKey, column] of Object.entries(newTableColumns)) {
    if (column.mandatory === false && column.display === true) {
      newTableColumns[columnKey].display = false;
    }
  }

  Object.values(selectedColumns).forEach((key) => {
    if (newTableColumns[key]) newTableColumns[key].display = true;
  });
};

export const scrollTableToTop = (id) => {
  const element = document.getElementById(id);
  if (element) {
    setTimeout(() => {
      element.scrollTop = 0;
    }, 10);
  }
};

/**
 * Checks if a click event has modifier keys pressed (Cmd/Ctrl/Shift).
 * Used to allow native browser behavior for opening links in new tab/window.
 * - Cmd+Click (Mac) / Ctrl+Click (Windows/Linux) → New tab
 * - Shift+Click → New window
 * @param {MouseEvent} event - The click event
 * @returns {boolean} - True if modifier key is pressed
 */
export const isModifierClick = (event) => event.metaKey || event.ctrlKey || event.shiftKey;
